import { Box, Container, Skeleton } from '@mui/material'
import { useGenreList } from 'app/_components/SelectGenre/_hooks/useGetGenre'
import { GenreSelectCard } from './GenreSelectCard'

export const SelectGenre = () => {
  const genreList = useGenreList()

  return (
    <Box
      sx={{
        bgcolor: 'black',
        position: 'sticky',
        top: { md: 64, xs: 56 },
        py: 0.5,
        zIndex: 1,
      }}
    >
      <Container maxWidth='xl'>
        <Box sx={{ display: 'flex', gap: 1, mx: { md: 2, xs: 1 } }}>
          {genreList === 'loading'
            ? [...Array(3)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant='rectangular'
                  width={110}
                  height={30}
                  sx={{ borderRadius: 80 }}
                />
              ))
            : genreList.map((category) => (
                <GenreSelectCard
                  key={category.id}
                  category_name={category.name ?? ''}
                  sub_categories={category.categories ?? []}
                />
              ))}
        </Box>
      </Container>
    </Box>
  )
}
